import * as types from './student.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	get: payload => ({
		type: types.GET_STUDENT,
		payload,
	}),
	set: payload => ({
		type: types.SET_STUDENT,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_STUDENT,
		payload,
	}),
	remove: payload => ({
		type: types.REMOVE_STUDENT,
		payload,
	}),
	getStaticOptions: payload => ({
		type: types.GET_STATIC_OPTIONS,
		payload,
	}),
	getDynamicOptions: payload => ({
		type: types.GET_DYNAMIC_OPTIONS,
		payload,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setInformation: payload => ({
		type: types.SET_INFORMATION,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
